import React, { lazy, Suspense } from 'react';

import type { SearchResultsReturnBannerProps } from './SearchResultsReturnBanner';

const LazySearchResultsReturnBanner = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant_search-results-return-banner" */
		'./SearchResultsReturnBanner'
	).then(({ SearchResultsReturnBanner }) => ({
		default: SearchResultsReturnBanner,
	})),
);

export const AsyncSearchResultsReturnBanner = (
	props: SearchResultsReturnBannerProps,
): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySearchResultsReturnBanner {...props} />
	</Suspense>
);
